export const APP_VERSION = "0.1.9-2024.02.20";
export const GIT_COMMIT = "5da7e30456344b98d0ccced9595809aaf0e4b1b1";
export const tellUsAboutYourselfPageURL = "/your-friend-has-a-few-questions/";
export const AMAZON_LINK_CODE = "ll1";
export const AMAZON_TAG = "generousgiv0c-20";
export const MAX_NUMBER_FRIENDS_FREE = 30;
